import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';

const ACTIVE_ROUTES = [
    'formulaireFormIndex',
    'formulaireFormIndexDiscussion',
    'formulaireFormIndexUser',
    'formulaireFormEdit',
    'formulaireSubmissionIndex',
];

// @ts-ignore Missing view() typings in Flarum
export default class SettingsLinkButton extends LinkButton {
    static initAttrs(attrs: any) {
        super.initAttrs(attrs);

        attrs.active = this.isActive(attrs);
        attrs.icon = 'fas fa-poll-h';
        attrs.href = app.route('formulaireFormIndex');
    }

    getButtonContent() {
        return super.getButtonContent(app.translator.trans('kilowhat-formulaire.forum.nav.forms'));
    }

    static isActive(attrs: any) {
        return m.route.get() === attrs.href || ACTIVE_ROUTES.indexOf((app.current.data as any).routeName) !== -1;
    }
}
